<div id="events-overlay" class="bottom-center-overlay bgc-glass" [ngStyle]="overlayStyles">
  @if (getRoleDisplayName() !== '') {
    <p class="larger-font"> Save the date! Register today for one of our </p>
    <app-events-list [role]="role" [region]="region" (linkClick)="onLinkClick()"></app-events-list>
  } @else {
    <p class="larger-font">
      Save the date! Register today for one of our
      <a
        class="overlay-link"
        href="https://orchestrators.genesys.com/resources/genesys-news-and-events?product=genesys-cloud-cx#events"
        target="_blank"
        title="Genesys Events"
        >Genesys Events</a
      >.
    </p>
  }
</div>
